import { render, staticRenderFns } from "./AttachDelivery.vue?vue&type=template&id=1296c52d&scoped=true&"
import script from "./AttachDelivery.vue?vue&type=script&lang=js&"
export * from "./AttachDelivery.vue?vue&type=script&lang=js&"
import style0 from "./AttachDelivery.vue?vue&type=style&index=0&id=1296c52d&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1296c52d",
  null
  
)

export default component.exports